import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Lock } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, hasConsent, loading } = useAuth();
  const navigate = useNavigate();

  // Show loading state while auth is initializing
  if (loading) {
    return (
      <div className="consent-required-page">
        <div className="consent-required-container">
          <div className="loading-spinner">Loading...</div>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If no consent, show consent required page
  if (!hasConsent) {
    return (
      <div className="consent-required-page">
        <div className="consent-required-container">
          <div className="consent-required-icon"><Lock size={32} /></div>
          <h2>Consent Required</h2>
          <p>
            Please acknowledge and give consent to data collection before accessing this module.
          </p>
          <p className="consent-required-subtitle">
            This ensures we comply with research and privacy requirements.
          </p>
          <button
            className="consent-required-button"
            onClick={() => navigate('/home')}
          >
            Go to Home Page
          </button>
        </div>
      </div>
    );
  }

  // Consent granted - render the protected component
  return children;
};

export default ProtectedRoute;
